/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable import/prefer-default-export */
import { AxiosError } from 'axios';
import { RemoteError } from '../interfaces/RemoteData';

export const throwLoaderError = <T = RemoteError>(e: AxiosError<T>): never => {
	throw e.response?.data || e;
};
